import FormButton from './FormButton'
import FormInput from './FormInput'
import FormPlainInput from './FormPlainInput'
import FormSMSInput from './FormSMSInput'
import { registerComponents } from '@/utils/component'

const components = {
  FormButton,
  FormInput,
  FormPlainInput,
  FormSMSInput
}

export default {
  install (Vue) {
    registerComponents(Vue, components)
  }
}
